<app-page-title title="Responder Devocional"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<div class="form-container" *ngIf="quiz">
  <div class="header-actions">
    <button class="btn-secundary" [routerLink]="['/devocional/view', quiz.id]">Cancelar</button>
  </div>

  <div class="card-form">
    <div class="quiz-context">
      <h2 class="quiz-title">{{ quiz.title }}</h2>
      <p class="quiz-instruction">
        Leia o devocional na tela anterior e preencha suas reflexões abaixo. Pelo menos uma pergunta deve ser respondida
        para salvar.
      </p>
    </div>

    <form [formGroup]="respondForm" (ngSubmit)="onSubmit()">
      <div class="qa-block">
        <p class="question-title">{{ quiz.question_1 }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="answer_1" rows="3" placeholder="Sua resposta..."></textarea>
        </mat-form-field>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ quiz.question_2 }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="answer_2" rows="3" placeholder="Sua resposta..."></textarea>
        </mat-form-field>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ quiz.question_3 }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="answer_3" rows="3" placeholder="Sua resposta..."></textarea>
        </mat-form-field>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ quiz.question_4 }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="answer_4" rows="3" placeholder="Sua resposta..."></textarea>
        </mat-form-field>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ quiz.question_5 }}</p>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput formControlName="answer_5" rows="3" placeholder="Sua resposta..."></textarea>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn-primary" [disabled]="!hasAtLeastOneAnswer()">
          {{ isEditMode ? 'Atualizar Respostas' : 'Salvar Respostas' }}
        </button>
      </div>
    </form>
  </div>
</div>
